module.exports = __webpack_public_path__ + "img/1@2x.14312e2e.png";